document.documentElement.classList.add("js");

const navToggle = document.querySelector(".nav-toggle");
const primaryNav = document.querySelector(".primary-nav");

if (navToggle && primaryNav) {
  navToggle.addEventListener("click", () => {
    const isOpen = primaryNav.classList.toggle("is-open");
    navToggle.setAttribute("aria-expanded", String(isOpen));
  });
}

document.querySelectorAll("[data-qty-minus]").forEach((button) => {
  button.addEventListener("click", () => {
    const input = button.parentElement.querySelector("input");
    input.value = Math.max(Number(input.min || 1), Number(input.value || 1) - 1);
    input.dispatchEvent(new Event("change", { bubbles: true }));
  });
});

document.querySelectorAll("[data-qty-plus]").forEach((button) => {
  button.addEventListener("click", () => {
    const input = button.parentElement.querySelector("input");
    input.value = Number(input.value || 1) + 1;
    input.dispatchEvent(new Event("change", { bubbles: true }));
  });
});

const cartSection = document.querySelector("[data-cart-section]");

function evergreenFormatMoney(cents, format) {
  const value = Number(cents || 0) / 100;
  const amount = value.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  if (!format) return `$${amount}`;
  return format
    .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(value).toLocaleString())
    .replace(/\{\{\s*amount\s*\}\}/g, amount)
    .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace(".", ","));
}

function updateHeaderCartCount(count) {
  document.querySelectorAll(".cart-link span").forEach((target) => {
    target.textContent = count;
  });
}

function updateCartProgress(cart, section) {
  const threshold = Number(section.dataset.freeDeliveryThreshold || 0);
  const progressWrap = section.querySelector("[data-delivery-progress]");
  if (!progressWrap || threshold <= 0) return;
  const format = section.dataset.moneyFormat;
  const message = section.querySelector("[data-progress-message]");
  const bar = section.querySelector("[data-progress-bar]");
  const remaining = threshold - cart.total_price;
  const progress = Math.min(100, Math.max(0, (cart.total_price / threshold) * 100));
  if (message) {
    message.textContent = remaining > 0
      ? `${section.dataset.progressPrefix || "You're"} ${evergreenFormatMoney(remaining, format)} ${section.dataset.progressSuffix || "away from FREE Auckland delivery"}`
      : section.dataset.progressComplete || "You qualify for FREE Auckland delivery";
  }
  if (bar) bar.style.width = `${progress}%`;
}

function refreshCartDom(cart, section) {
  const format = section.dataset.moneyFormat;
  const subtotal = section.querySelector("[data-cart-subtotal]");
  const count = section.querySelector("[data-cart-count]");
  if (subtotal) subtotal.textContent = evergreenFormatMoney(cart.total_price, format);
  if (count) count.textContent = cart.item_count;
  updateHeaderCartCount(cart.item_count);
  updateCartProgress(cart, section);

  const itemsByKey = new Map(cart.items.map((item) => [item.key, item]));
  section.querySelectorAll("[data-cart-item]").forEach((itemNode) => {
    const key = itemNode.dataset.lineKey;
    const item = itemsByKey.get(key);
    if (!item) {
      itemNode.remove();
      return;
    }
    const quantityInput = itemNode.querySelector("[data-cart-quantity]");
    const lineTotal = itemNode.querySelector("[data-line-total]");
    if (quantityInput) quantityInput.value = item.quantity;
    if (lineTotal) lineTotal.textContent = evergreenFormatMoney(item.final_line_price, format);
  });

  if (cart.item_count === 0) window.location.reload();
}

async function changeCartLine(section, key, quantity) {
  section.classList.add("is-updating");
  try {
    const response = await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id: key, quantity })
    });
    if (!response.ok) throw new Error("Cart update failed");
    const cart = await response.json();
    refreshCartDom(cart, section);
  } catch (error) {
    const form = section.querySelector(".cart-items");
    if (form) form.submit();
  } finally {
    section.classList.remove("is-updating");
  }
}

if (cartSection) {
  cartSection.querySelectorAll("[data-cart-quantity]").forEach((input) => {
    input.addEventListener("change", () => {
      const item = input.closest("[data-cart-item]");
      if (!item) return;
      changeCartLine(cartSection, item.dataset.lineKey, Math.max(0, Number(input.value || 0)));
    });
  });

  cartSection.querySelectorAll("[data-cart-remove]").forEach((link) => {
    link.addEventListener("click", (event) => {
      event.preventDefault();
      const item = link.closest("[data-cart-item]");
      if (!item) return;
      changeCartLine(cartSection, item.dataset.lineKey, 0);
    });
  });
}

const mainProductImage = document.querySelector("[data-main-product-image]");

document.querySelectorAll("[data-gallery-thumb]").forEach((button) => {
  button.addEventListener("click", () => {
    if (!mainProductImage) return;
    const image = button.dataset.galleryImage;
    const zoom = button.dataset.galleryZoom || image;
    const alt = button.dataset.galleryAlt || "";
    if (!image) return;
    mainProductImage.src = image;
    mainProductImage.alt = alt;
    mainProductImage.dataset.zoomSrc = zoom;
    document.querySelectorAll("[data-gallery-thumb]").forEach((thumb) => thumb.classList.remove("is-active"));
    button.classList.add("is-active");
  });
});

document.querySelectorAll(".variant-select select").forEach((select) => {
  select.addEventListener("change", () => {
    const selected = select.options[select.selectedIndex];
    const price = selected && selected.dataset.price;
    const summary = select.closest(".product-summary");
    const priceTarget = summary && summary.querySelector("[data-product-price]");
    if (price && priceTarget) priceTarget.textContent = price;
  });
});

const zoomModal = document.querySelector("[data-product-zoom-modal]");
const zoomImage = document.querySelector("[data-product-zoom-image]");
const zoomClose = document.querySelector("[data-product-zoom-close]");

document.querySelectorAll("[data-product-zoom]").forEach((button) => {
  button.addEventListener("click", () => {
    if (!zoomModal || !zoomImage || !mainProductImage) return;
    zoomImage.src = mainProductImage.dataset.zoomSrc || mainProductImage.src;
    zoomImage.alt = mainProductImage.alt || "";
    zoomModal.hidden = false;
    document.body.classList.add("has-open-modal");
    zoomClose && zoomClose.focus();
  });
});

function closeProductZoom() {
  if (!zoomModal) return;
  zoomModal.hidden = true;
  document.body.classList.remove("has-open-modal");
}

if (zoomClose) zoomClose.addEventListener("click", closeProductZoom);
if (zoomModal) {
  zoomModal.addEventListener("click", (event) => {
    if (event.target === zoomModal) closeProductZoom();
  });
}

document.addEventListener("keydown", (event) => {
  if (event.key === "Escape") closeProductZoom();
});

document.querySelectorAll("product-recommendations[data-url]").forEach((container) => {
  fetch(container.dataset.url)
    .then((response) => response.text())
    .then((text) => {
      const html = document.createElement("div");
      html.innerHTML = text;
      const recommendations = html.querySelector("product-recommendations");
      if (recommendations && recommendations.innerHTML.trim().length) {
        container.innerHTML = recommendations.innerHTML;
      }
    })
    .catch(() => {});
});

document.querySelectorAll("[data-collection-view]").forEach((button) => {
  button.addEventListener("click", () => {
    const grid = document.querySelector("[data-collection-grid]");
    if (!grid) return;
    document.querySelectorAll("[data-collection-view]").forEach((viewButton) => viewButton.classList.remove("is-active"));
    button.classList.add("is-active");
    grid.classList.toggle("is-list-view", button.dataset.collectionView === "list");
  });
});
